import { Catalogue, DataStatus, PriceType } from '../types';
import { CatalogueStats } from '../types/catalogue-stats';

export function getCatalogueStats(catalogue: Catalogue): CatalogueStats {
  if (catalogue.statusAll !== DataStatus.LOADED) {
    return {
      priceTotals: {
        status: catalogue.statusAll,
      },
      deviceTotals: {
        status: catalogue.statusAll,
      },
    };
  }

  return catalogue.products.reduce<CatalogueStats>(
    (result, product) => {
      if (product.device.quantity === undefined) {
        return result;
      }
      if (result.priceTotals.status === DataStatus.LOADED) {
        return {
          priceTotals: {
            status: DataStatus.LOADED,
            monthly:
              product.price.priceType === PriceType.MONTHLY
                ? (result.priceTotals.monthly || 0) +
                  (product.price.price || 0) * product.device.quantity
                : result.priceTotals.monthly || 0,
            onceOff:
              product.price.priceType === PriceType.ONCE_OFF
                ? (result.priceTotals.onceOff || 0) +
                  (product.price.price || 0) * product.device.quantity
                : result.priceTotals.onceOff,
          },
          deviceTotals: {
            totalDevices: (result.deviceTotals.totalDevices || 0) + (product.device.quantity || 0),
            status: DataStatus.LOADED,
          },
        };
      } else {
        return {
          priceTotals: {
            status: DataStatus.LOADING,
          },
          deviceTotals: {
            status: DataStatus.LOADED,
          },
        };
      }
    },
    {
      priceTotals: {
        status: DataStatus.LOADED,
      },
      deviceTotals: {
        status: DataStatus.LOADED,
        totalDevices: 0,
      },
    },
  );
}
